import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=68a05076"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a05076')) {
      api.createRecord('68a05076', component.options)
    } else {
      api.reload('68a05076', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=68a05076", function () {
      api.rerender('68a05076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/components/Question.vue"
export default component.exports